import axios, { AxiosResponse, AxiosError } from 'axios';

import { MonthlyDatesResponse } from '../types';

export const useGetMonthlyDates = async () =>
  axios({
    method: 'get',
    url: '/wp-json/wp/v2/monthly/dates',
  })
    .then((res: AxiosResponse<MonthlyDatesResponse>) => {
      const result = res.data;
      return result;
    })
    .catch((error: AxiosError<{ error: string }>) => {
      // eslint-disable-next-line no-console
      console.log(error);
    });
